export enum CertificateType {
  CONSUMPTION = 'CONSUMPTION',
  DEMAND = 'DEMAND',
}

export enum ServiceType {
  FULL_SERVICE = 'FULL_SERVICE',
  SELF_SERVICE = 'SELF_SERVICE',
  PLUS_SERVICE = 'PLUS_SERVICE',
  VIDEO_SERVICE = 'VIDEO_SERVICE', // 'VIDEO_SERVICE'
}
